import React, { useContext, useEffect, useState } from 'react';
import CardUserModal from '@/components/Card/CardUserModal';
import {
  addGlobalScanListener,
  removeGlobalScanListener,
} from '@/components/QRScanner/GlobalScanner';
import { playSound } from '@/utils/sound';
import { OrderDetailModal } from '../Order/DetailModal';
import { BaseInfoContext } from '@/context/BaseInfoContext';

const ScanResponder: React.FC = ({}) => {
  const [, , helpers] = useContext(BaseInfoContext);
  const [orderSn, setOrderSn] = useState<string>();
  const [cardUserSn, setCardUserSn] = useState<string>();

  useEffect(() => {
    const keys = [
      // 订单
      addGlobalScanListener('order', ({ code: value }) => {
        playSound('scan_di');
        helpers.showOrderModal({ orderSn: value });
      }),
      // 用户
      addGlobalScanListener('user', ({ code: value }) => {
        playSound('scan_di');
        helpers.showUserModal({ userName: value });
      }),
      // 预付卡
      addGlobalScanListener('card', ({ code: value }) => {
        playSound('scan_di');
        setCardUserSn(value);
      }),
    ];
    return () => {
      removeGlobalScanListener(...keys);
    };
  }, []);

  return (
    <>
      <OrderDetailModal
        orderSn={orderSn}
        onClose={() => {
          setOrderSn(null);
        }}
      />
      <CardUserModal
        cardUserSn={cardUserSn}
        onClose={() => {
          setCardUserSn(null);
        }}
      />
    </>
  );
};

export default ScanResponder;
